export const developer = {
  developers: 'Razvijači',
  enpowerYourDevelopersToHarnessTheFullPotential: 'Ovlaštite svoje razvijače da iskoriste puni potencijal vašeg nadzorne ploče',
  accessToken: 'Pristupni token',
  yourAPI: 'Vaši API-ji',
  api: {
    apiManagement: 'Upravljanje API-ima',
    apiManagementSubHeading: 'Dodajte, konfigurirajte, testirajte i upravljajte svojim API-ima koje možete koristiti za pokretanje razgovornih tokova.',
    addApi: 'Dodaj API',
    createApi: 'Stvori API',
    noApiFound: 'Nema pronađenih API-ja!',
    deleteApis: 'Izbriši API-je',
    areYouSureYouWantToDeleteAPI: `Jeste li sigurni da želite izbrisati API-je`,
    placeholders: {
      search: `Pretraži po nazivu API-ja`
    },
    tableHead: {
      method: 'Metoda',
      apiName: 'Naziv API-ja',
      url: 'URL',
      actions: 'Akcije'
    },
    parametersTab: 'Parametri',
    headersTab: 'Zaglavlja',
    bodyTab: 'Tablica tijela',
    manageApiResponses: 'Upravljanje odgovorima API-ja',
    chooseVariableToSave: 'Odaberite varijablu za spremanje',
    selectCustomAttribute: 'Odaberite prilagođeni atribut',
    subTab: {
      key: 'Ključ',
      enterKey: 'Unesite ključ',
      value: 'Vrijednost',
      enterValue: 'Unesite vrijednost',
      addAnotherField: 'Dodajte još jedno polje',
      save: 'Spremi',
      useslashToInsertCustomVariables: `Koristite '/' za umetanje prilagođenih varijabli ili dinamičkih vrijednosti iz odgovora korisnika.`,
      response: 'Odgovor',
      apiRequestBody: 'Tijelo zahtjeva API-ja',
      hit: 'Pogodak',
      test: 'Test',
      buttonToGetAResponse: 'gumb za dobivanje odgovora',
      variable: 'Varijabla',
      saveToCustomAttribute: 'Spremi u prilagođeni atribut',
      encryptedKey: 'Ključ (šifrirano)',
      noOptionsAvailable: 'Nema dostupnih opcija',
      addAuthenticationField: 'Dodajte polje za provjeru autentičnosti'
    },
    apiLogs: {
      apiManagement: 'Upravljanje API-ima',
      addConfigureTestAndManageYourAPIs: 'Dodajte, konfigurirajte, testirajte i upravljajte svojim API-ima koje možete koristiti za pokretanje razgovornih tokova.',
      searchHere: 'Pretraži prema statusnom kodu',
      deleteApis: 'Izbriši API-je',
      testAnApi: 'Testirajte API',
      noAPILogFound: 'Nije pronađen zapisnika API-ja',
      responseCode: 'Kod odgovora',
      message: 'Poruka',
      apiResponse: 'Odgovor API-ja',
      actions: 'Akcije',
      deleteAPIs: 'Izbriši zapise API-ja',
      areYouSureYouWantToDelete: 'Jeste li sigurni da želite izbrisati ovaj zapisnik API-ja?',
      apiLogs: 'Zapisi API-ja',
      subTitle: 'Detaljni zapis svih API zahtjeva i odgovora pokrenutih unutar razgovornog toka četbot-a.'
    }
  },
  configApi: {
    configureApi: `Konfiguriraj API`,
    configureApiSubHeading: `Ovdje možete konfigurirati svoj JSON bazirani API i koristiti ga za obogaćivanje vašeg razgovornog toka`,
    apiLogs: `Zapisi API-ja`,
    test: `Test`,
    manageApiResponse: `Upravljanje odgovorima API-ja`,
    body: `Tijelo`,
    headers: `Zaglavlja`,
    parameters: `Parametri`,
    testyourRequest: 'Testirajte svoj zahtjev',
    testRequestDescription: 'Vaš zahtjev sadrži varijable, možete ručno postaviti njihove vrijednosti u svrhu testiranja.',
    apiName: 'Naziv API-ja',
    placeholders: {
      enterApiName: `Unesite naziv API-ja`,
      enterApiUrl: `Unesite URL API-ja`,
      enterTestValue: 'Unesite testnu vrijednost'

    }
  }
};
